import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './Cta9.styled'

export const useCta9 = props => {
	const { metaData } = props
	const classes = useStyles(props)

	const sectionId = useSectionId()

	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const columnsNumber = Math.min(metaData.columns?.toNumber(), _.size(items))

	let maxWidth

	switch (columnsNumber) {
		case 2:
			maxWidth = 'md'
			break
		case 1:
			maxWidth = 'sm'
			break
		default:
			break
	}

	return [
		{
			classes,
			maxWidth,
			columnsNumber,
			items,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',
		},
	]
}
